/**
 * Vocabulary configuration registry.
 *
 * Defines all vocabulary names and their properties in a centralized,
 * type-safe manner. This enables easy management of vocabulary identifiers
 * without scattering magic strings throughout the codebase.
 */

export interface VocabularyDefinition {
  id: string;
  name: string;
  description?: string;
}

export const VOCABULARIES = {
  // News categorization
  NEWS_THEMES: {
    id: 'vocab_news_themes',
    name: 'ministerio.publico.federal.noticiatemas',
    description: 'Available themes for news items',
  },

  // Organizational units
  ORIGIN_UNITS: {
    id: 'vocab_origin_units',
    name: 'ministerio.publico.federal.unidades_origem',
    description: 'Organizational units that can be news origin',
  },

  // Portal types for search
  PORTAL_TYPES_SEARCH: {
    id: 'vocab_portal_types',
    name: 'plone.app.vocabularies.AllowedContentTypes',
    description: 'All available content types for search filtering',
  },
} as const;

export type VocabularyKey = keyof typeof VOCABULARIES;

/**
 * Get vocabulary name by key.
 * @param key - The vocabulary key from VOCABULARIES
 * @returns The vocabulary name/identifier
 */
export function getVocabularyName(key: VocabularyKey): string {
  return VOCABULARIES[key].name;
}

/**
 * Get vocabulary definition by key.
 * @param key - The vocabulary key from VOCABULARIES
 * @returns The full vocabulary definition
 */
export function getVocabularyDefinition(
  key: VocabularyKey,
): VocabularyDefinition {
  return VOCABULARIES[key];
}
